import {isDebugMode} from './isDebugMode'

interface IDebugLoggerProperties {
  message: string
  tag?: string
  data?: any
}

export const debugLogger = (props: IDebugLoggerProperties) => {
  const {message, tag, data} = props

  if (isDebugMode()) {
    console[data ? 'groupCollapsed' : 'log'](
      `%c 🪵${tag ? ` [${tag}]:` : ':'} `,
      'background: white; color: red; font-size: 14px;',
      message,
    )
    if (data) {
      console.log(data)
    }

    console.groupEnd()
  }
}
